export interface IInventoryUniqueItem {
  uniqueItemId?: string;
  itemId: string;
  itemIdentifier: string;
  expDate: string;
  manufacturerId?: string;
  vendorId?: string;
  parentContainerId?: string;
  isBroken?: boolean;
  isActive?: boolean;
  modifiedBy?: string;
  modifiedDate?: string;
  toolNotes?: string;
  warehouseId?: number;
  warehouseName?: string;
  subLocationId?: number;
  subLocationName?: string;
}
